/**
 * @flow
 */
'use strict';

export const occupationAutreCodes = [
{"code":"++ ordi 8h/j"},
{"code":"++ordi"},
{"code":"15238"},
{"code":"1ere annee"},
{"code":"4e année"},
{"code":"6eannée"},
{"code":"Administration"},
{"code":"Analyste informatique"},
{"code":"Ancienne cuisinière"},
{"code":"Aucun"},
{"code":"Audi"},
{"code":"Audiologie"},
{"code":"Autre Occupation 1"},
{"code":"Baseball"},
{"code":"Bombardier"},
{"code":"C.P.E."},
{"code":"Caméraman"},
{"code":"Cegep"},
{"code":"Clsc"},
{"code":"Collégiale"},
{"code":"Comptabilite"},
{"code":"Concordia"},
{"code":"Construction"},
{"code":"Course"},
{"code":"Curling"},
{"code":"DateExamen"},
{"code":"Design"},
{"code":"Design intérieur"},
{"code":"Doctorat neuropsychologie"},
{"code":"Ecole"},
{"code":"Ecole alternative"},
{"code":"Emploi pharmacie"},
{"code":"En septembre"},
{"code":"Encore 1 1/2 ans avant maternelle"},
{"code":"Enseignante"},
{"code":"Enseignement"},
{"code":"Etudiante"},
{"code":"Football"},
{"code":"Golf"},
{"code":"Gymnastique"},
{"code":"Heroux devtek"},
{"code":"Hockey"},
{"code":"Hydro qc"},
{"code":"Informatique"},
{"code":"Karaté"},
{"code":"Laval"},
{"code":"Microscope"},
{"code":"Milieu médicale"},
{"code":"Montréal"},
{"code":"Nouveau"},
{"code":"Néo natalogie"},
{"code":"Ordi"},
{"code":"Ordi ++"},
{"code":"Patrouilleur ski Jay Peak"},
{"code":"Pfizer"},
{"code":"Pharmacie"},
{"code":"Philosophie"},
{"code":"Physiothérapie"},
{"code":"Pilote avion"},
{"code":"Pratt and withney"},
{"code":"Primaire"},
{"code":"Préscolaire"},
{"code":"Publicité"},
{"code":"Quilles"},
{"code":"Renovation"},
{"code":"Resident"},
{"code":"Ressource humaine"},
{"code":"Retraité"},
{"code":"Sc.humaine (veut aller en droit)"},
{"code":"Sc.humaines"},
{"code":"Sc.nature"},
{"code":"Sciences"},
{"code":"Secondaire"},
{"code":"Soccer"},
{"code":"Soin infirmier"},
{"code":"Tenis"},
{"code":"Universitaire"},
{"code":"Velo"},
{"code":"Vente"},
{"code":"Ville de Motréal"},
{"code":"Était bijoutier"},
]
